import { TextInputProps as RNTextInputProps } from "react-native"
import MagnifyingGlassIcon from "../assets/magnifying-glass-icon.svg"
import ClearIcon from "../assets/v2/Clear.svg"
import styled from "@emotion/native"
import { useTheme } from "@emotion/react"
import { StyleProp, TextStyle } from "react-native"

type SearchBarProps = RNTextInputProps & {
  additionalStyles?: StyleProp<TextStyle>
}

export function SearchBar(props: SearchBarProps) {
  const theme = useTheme()
  const clearContent = () => {
    if (props.onChangeText) {
      props.onChangeText("")
    }
  }

  return (
    <InputContainer>
      <IconWrapper>
        <MagnifyingGlassIcon
          color={(props.placeholderTextColor as string) || theme.textInput.textColor}
        />
      </IconWrapper>
      <StyledTextInput
        placeholderTextColor={theme.textInput.textColor}
        {...props}
        style={props.additionalStyles}
        maxFontSizeMultiplier={1.5}
      />
      <ClearIconWrapper onPress={clearContent}>
        <ClearIcon />
      </ClearIconWrapper>
    </InputContainer>
  )
}

const InputContainer = styled.View`
  position: relative;
  width: 100%;
`

const IconWrapper = styled.View`
  position: absolute;
  left: 12px;
  top: 12.5px;
  z-index: 1;
`

const ClearIconWrapper = styled.Pressable`
  position: absolute;
  right: 12px;
  top: 12.5px;
  z-index: 1;
`

const StyledTextInput = styled.TextInput`
  background-color: ${({ theme }) => theme.textInput.backgroundColor};
  width: 100%;
  height: 45px;
  font-size: 18px;
  line-height: 21px;
  padding: 0 42px;
  color: black;
`
